"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDateLabelText = void 0;
const getDateLabelText = (label, displayFormat) => {
    var _a, _b;
    return label
        ? `${label} (${displayFormat ||
            ((_b = (_a = window === null || window === void 0 ? void 0 : window.I18n) === null || _a === void 0 ? void 0 : _a.t) === null || _b === void 0 ? void 0 : _b.call(_a, 'date.formats.date_picker')) ||
            'date.formats.date_picker'})`
        : '';
};
exports.getDateLabelText = getDateLabelText;
//# sourceMappingURL=index.js.map